import { useState } from 'react';
import { AdminLayout } from './AdminLayout';
import { AdminDashboard } from './Dashboard/AdminDashboard';
import { LeadDashboard } from './Dashboard/LeadDashboard';
import { ProfessionalsDashboard } from './Dashboard/ProfessionalsDashboard';
import { ChatbotAdmin } from './Dashboard/ChatbotAdmin';
import { AdminMarketplace } from './Dashboard/AdminMarketplace';
// Commented out - may need later
// import { PromoteProfessional } from "./Dashboard/PromoteProfessional";

export function Admin({ idToken, username, onSignOut }) {
  const [activeSection, setActiveSection] = useState('dashboard');

  const renderSection = () => {
    switch (activeSection) {
      case 'dashboard':
        return <AdminDashboard idToken={idToken} onNavigate={setActiveSection} />;
      case 'marketplace':
        return <AdminMarketplace idToken={idToken} isAdmin={true} />;
      case 'quote-leads':
        return <LeadDashboard idToken={idToken} />;
      case 'professionals':
        return <ProfessionalsDashboard idToken={idToken} />;
      case 'chatbot':
        return <ChatbotAdmin idToken={idToken} />;
      default:
        return <AdminDashboard idToken={idToken} onNavigate={setActiveSection} />;
    }
  };

  return (
    <AdminLayout
      activeSection={activeSection}
      onSectionChange={setActiveSection}
      isAdmin={true}
      username={username}
      onSignOut={onSignOut}
    >
      {renderSection()}
    </AdminLayout>
  );
}
